/**
 * Returns the tours where the calling user is a collaborator (not the owner).
 * Backed by the standalone tourCollaborators GCF (`action: 'myTours'`).
 *
 * Returned shape matches getAllToursFast so the dashboard can merge
 * owned + collaborated tours transparently. Thumbnails arrive as Storage
 * paths and are resolved client-side via getThumbnailUrlFromStorage —
 * same post-process as the owner-tours endpoints.
 */

import { Tour } from 'app/types';

import { callCollaboratorsApi } from './collaboratorsApi';
import { getThumbnailUrlFromStorage } from './getThumbnailUrlFromStorage';

interface MyToursResult {
  success: boolean;
  tours: Tour[];
}

export async function getCollaboratedTours(): Promise<Tour[]> {
  const payload = await callCollaboratorsApi<MyToursResult>({
    action: 'myTours',
  });
  const tours = Array.isArray(payload?.tours) ? payload.tours : [];

  return Promise.all(
    tours.map(async (tour) => {
      if (!tour.thumbnailUrl) return tour;
      try {
        const url = await getThumbnailUrlFromStorage(tour.thumbnailUrl);
        return { ...tour, thumbnailUrl: url };
      } catch {
        return tour;
      }
    }),
  );
}
